import useGetApi from '../useGetApi';
import { QuoteSheetDTO } from './quote-sheets-types';

export function useGetQuoteSheet(quoteSheetId: string) {
  return useGetApi<QuoteSheetDTO>({
    endpoint: `accounts-payable/quote-sheets/${quoteSheetId}`,
  });
}
